/**
 * Card scoring / name normalization helpers.
 *
 * The full mobile `cardScoringEngine.ts` is part of the camera/OCR scan
 * pipeline (TcgSetCard scoring, OCR signals, candidate ranking) which is
 * explicitly out of scope for the web port per the project briefing. Only the
 * pure name-normalization helper is needed by non-scan code paths
 * (e.g. `deckInventoryMatcher`), so we keep just that one here under the
 * same import path so any future full port doesn't have to rewire imports.
 */

const DIACRITICS = /[̀-ͯ]/g;
const APOSTROPHES = /['’`]/g;
const NON_ALNUM = /[^a-z0-9]+/g;
const COLLAPSE_SPACE = /\s+/g;

/**
 * Lowercase + strip diacritics + drop apostrophes + collapse non-alphanumeric
 * runs to single spaces. Used by deck-list matching, family resolution, etc.
 * to compare card names robustly regardless of whitespace, capitalization, or
 * unicode normalization.
 */
export function normalizePokemonName(name: string): string {
  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(DIACRITICS, "")
    .replace(APOSTROPHES, "")
    .replace(NON_ALNUM, " ")
    .trim()
    .replace(COLLAPSE_SPACE, " ");
}
